import { render, staticRenderFns } from "./UserKartei.vue?vue&type=template&id=ede91748&scoped=true"
import script from "./UserKartei.vue?vue&type=script&lang=js"
export * from "./UserKartei.vue?vue&type=script&lang=js"
import style0 from "./UserKartei.vue?vue&type=style&index=0&id=ede91748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede91748",
  null
  
)

export default component.exports